export const ActionTypes = {
  SET_LATEST_OUTCOMES: '[KAMBI WIDGET] SET_LATEST_OUTCOMES',
  SET_QUEUED_OUTCOME: '[KAMBI WIDGET] SET_QUEUED_OUTCOME',
  CLEAR_QUEUED_OUTCOMES: '[KAMBI WIDGET] CLEAR_QUEUED_OUTCOMES',
  CLIENT_INIT_SUCCEEDED: '[KAMBI WIDGET] CLIENT_INIT_SUCCEEDED',

};

export class Actions {
  static setLatestOutcomes(outcomes) {
    return {
      type: ActionTypes.SET_LATEST_OUTCOMES,
      outcomes
    };
  }

  static setQueuedOutcome(outcome) {
    return {
      type: ActionTypes.SET_QUEUED_OUTCOME,
      outcome
    };
  }

  static clearQueuedOutcomes() {
    return {
      type: ActionTypes.CLEAR_QUEUED_OUTCOMES
    };
  }

  static clientInitSucceeded() {
    return {
      type: ActionTypes.CLIENT_INIT_SUCCEEDED
    };
  }
}
